var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOff1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 59,
    viewBox: "0 0 127 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2994",
    "data-name": "Groupe 2994",
    transform: "translate(-66 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(103.813 26.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,59V21.2L25.5,0,36.975,9.539V6.713h5.95v7.773L51,21.2V59Z",
    transform: "translate(0.187 -0.087)",
    fill: "#909da2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(3.921 4.984)",
    fill: "#909da2",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.72003555297852 50.15515518188477 L 0.7500039339065552 50.15515518188477 L 0.7500039339065552 18.07644653320312 L 21.73928451538086 0.9676777720451355 L 42.72003555297852 18.07636451721191 L 42.72003555297852 50.15515518188477 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.73919486999512 1.935333251953125 L 1.499992370605469 18.43270111083984 L 1.499992370605469 49.40514373779297 L 41.97002410888672 49.40514373779297 L 41.97002410888672 18.43251419067383 L 21.73919486999512 1.935333251953125 M 21.73938369750977 -7.62939453125e-06 L 43.47002410888672 17.72019195556641 L 43.47002410888672 50.90514373779297 L -7.62939453125e-06 50.90514373779297 L -7.62939453125e-06 17.72019195556641 L 21.73938369750977 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(65.514 41.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M0,43V15.449L19,0l8.55,6.952V4.892h4.433v5.665L38,15.449V43Z",
    transform: "translate(0.486 0.161)",
    fill: "#ebeced"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-2",
    "data-name": "Path 2",
    transform: "translate(2.94 3.651)",
    fill: "#ebeced",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.29750442504883 36.7789192199707 L 0.7500041127204895 36.7789192199707 L 0.7500041127204895 13.42015266418457 L 16.02687454223633 0.9676737785339355 L 31.29750442504883 13.42006969451904 L 31.29750442504883 36.7789192199707 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.02678489685059 1.935337066650391 L 1.500003814697266 13.77640533447266 L 1.500003814697266 36.0289192199707 L 30.54750442504883 36.0289192199707 L 30.54750442504883 13.77622222900391 L 16.02678489685059 1.935337066650391 M 16.02697372436523 0 L 32.04750442504883 13.06389999389648 L 32.04750442504883 37.5289192199707 L 3.814697265625e-06 37.5289192199707 L 3.814697265625e-06 13.06389999389648 L 16.02697372436523 0 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-3",
    "data-name": "Group 2",
    transform: "translate(154.514 41.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-3",
    "data-name": "Combined Shape",
    d: "M0,43V15.449L19,0l8.55,6.952V4.892h4.433v5.665L38,15.449V43Z",
    transform: "translate(0.486 0.161)",
    fill: "#ebeced"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-3",
    "data-name": "Path 2",
    transform: "translate(2.94 3.651)",
    fill: "#ebeced",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.29750442504883 36.7789192199707 L 0.7500041127204895 36.7789192199707 L 0.7500041127204895 13.42015266418457 L 16.02687454223633 0.9676737785339355 L 31.29750442504883 13.42006969451904 L 31.29750442504883 36.7789192199707 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.02678489685059 1.935337066650391 L 1.500003814697266 13.77640533447266 L 1.500003814697266 36.0289192199707 L 30.54750442504883 36.0289192199707 L 30.54750442504883 13.77622222900391 L 16.02678489685059 1.935337066650391 M 16.02697372436523 0 L 32.04750442504883 13.06389999389648 L 32.04750442504883 37.5289192199707 L 3.814697265625e-06 37.5289192199707 L 3.814697265625e-06 13.06389999389648 L 16.02697372436523 0 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff1);
export default __webpack_public_path__ + "static/media/off__1_.892f92c130bb2d5b3ed3bf4fb247c31c.svg";
export { ForwardRef as ReactComponent };